module.exports = __webpack_public_path__ + "static/media/Video_Allow_Instruction_1.01a1e425.jpg";